import React, { useEffect } from "react";
import { LOCALSESSIONDATAKEYS, NATIVE_APP_SELECTION_ATTRIBUTE, NATIVE_APP_AUTHENTICATION_FLAG, NATIVE_APP_SUBSCRIPTION_ATTRIBUTE } from "../../constants/AppConstants";
import { 
    buildSkipRegistrationQSNativeApp, 
    buildOneBenefitPageQSNAtiveApp, 
    getNativeAppQueryParamsValuesByKey, 
    updateNativeAppQueryParams_LocalStorage, 
    buildDirectServicePageQSNativeApp,
    isEcoproOrBplusDirectServicePage
} from "../../constants/AppMethod";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { nativeAppRoutePaths } from "../../constants/Routes";
import Loader from "../../components/shared/loader/Loader";
import { useDispatch } from "react-redux";
import { NativeAppLogsInit } from "../../store/NativeAppLogs/NativeAppLogsSlice";

const SkipRegistration = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const serviceTypeSelected = parseInt(getNativeAppQueryParamsValuesByKey("selection"));
    const appSelectionAttrArr = [
        NATIVE_APP_SELECTION_ATTRIBUTE.SKIP, 
        NATIVE_APP_SELECTION_ATTRIBUTE.ECOPRO_SERVICE, 
        NATIVE_APP_SELECTION_ATTRIBUTE.BPLUS_SERVICE
    ];


    useEffect(() => {
        let QS = null;
        if(isEcoproOrBplusDirectServicePage()){
            QS = buildDirectServicePageQSNativeApp(NATIVE_APP_SUBSCRIPTION_ATTRIBUTE.SKIP);
        } else if(appSelectionAttrArr.includes(serviceTypeSelected)){
            QS = buildOneBenefitPageQSNAtiveApp(NATIVE_APP_SUBSCRIPTION_ATTRIBUTE.SKIP, NATIVE_APP_SUBSCRIPTION_ATTRIBUTE.SKIP);
        } else {
            QS = buildSkipRegistrationQSNativeApp(NATIVE_APP_AUTHENTICATION_FLAG.HAS_SKIPPED_AUTH);
        }
        updateNativeAppQueryParams_LocalStorage(null, QS, LOCALSESSIONDATAKEYS.NATIVE_APP_AUTH_TOKEN_INFO);
        dispatch(NativeAppLogsInit({isAppToWeb: true}))
        history.push(nativeAppRoutePaths.WEB_TO_APP_REDIRECTION);
        // eslint-disable-next-line
    }, []);

    return(
        <Loader />
    )
}

export default SkipRegistration;